import { useEffect } from "react"
import { batch, useSignal } from "@preact/signals-react"
import { useAppToast } from "@ui-seeker/app"
import {FORMAT_DATE_BACK, formatDate, isEmpty, postSubmit, scrollToComponent, stringToDate} from "@ui-seeker/utils"

import { useDigitalShelfRoleConfig } from "../../@hooks"
import {digitalShelfEvolutionFilters} from "../../@signals"


export default function useDigitalShelfEvolutionData() {
	const { showToast } = useAppToast()
	const { urlApiEvolution } = useDigitalShelfRoleConfig()

	const dataEvolution = useSignal({})
	const dataEvolutionKeys = useSignal({})
	const isLoadingDataEvolution = useSignal(false)
	const kpiKey = useSignal("")
	const country = useSignal("")
	const retailer = useSignal("")
	const brand = useSignal("")
    const dateRange = useSignal([])

    useEffect(() => {
		if (!isEmpty(digitalShelfEvolutionFilters.value)) batch(() => {
			isLoadingDataEvolution.value = true
            dataEvolution.value = {}
			showToast.promise(postSubmit(urlApiEvolution, digitalShelfEvolutionFilters.value).then(res => batch(() => {
                dataEvolution.value = res.chart
				dataEvolutionKeys.value = res.chartKeys
				country.value = res.country
				retailer.value = res.site
				brand.value = res.brand
				kpiKey.value = res.kpiKey
                dateRange.value = [stringToDate(digitalShelfEvolutionFilters.value.startDate), stringToDate(digitalShelfEvolutionFilters.value.endDate)]

                isLoadingDataEvolution.value = false
			})).catch(() => {
				showToast.error()
				isLoadingDataEvolution.value = false
			}
            ).finally(() => scrollToComponent('evolution-chart')))
		}) 

		if (isEmpty(digitalShelfEvolutionFilters.value)) batch( () => {
			dataEvolution.value = {}
			dataEvolutionKeys.value = {}
		})

	}, [JSON.stringify(digitalShelfEvolutionFilters.value)]);

    const onChange = (e) => {
        batch(() => {
            dateRange.value = e
            digitalShelfEvolutionFilters.value = {
                ...digitalShelfEvolutionFilters.value,
                startDate: formatDate(e[0], { format: FORMAT_DATE_BACK }),
                endDate: formatDate(e[1], { format: FORMAT_DATE_BACK }),
            }
        })
    }

    const resetEvolutionData = () => batch(() => {
		dataEvolution.value = {}
		dataEvolutionKeys.value = {}
		digitalShelfEvolutionFilters.value = {}
		kpiKey.value = ""
		country.value = ""
		retailer.value = ""
		brand.value = ""
		scrollToComponent('table-details')
	})

	return {
		dataEvolution: dataEvolution.value,
		isLoadingDataEvolution: isLoadingDataEvolution.value,
		dataEvolutionKeys: dataEvolutionKeys.value,
		country: country.value,
		retailer: retailer.value,
		brand: brand.value,
		kpiKey: kpiKey.value,
        dateRange: dateRange.value,

        onChange,
        resetEvolutionData
	}
}